import React from 'react';

interface HeadingHighlightProps {
  children: React.ReactNode;
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size?: 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';
  id?: string;
}

const sizeClasses = {
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
};

const HeadingHighlight: React.FC<HeadingHighlightProps> = ({ 
  children, 
  className = "",
  as: Component = 'h2',
  size = '3xl',
  id
}) => {
  const baseClasses = "relative inline-block font-bold mb-8";
  const highlightClasses = "relative z-[2] box-decoration-clone leading-[1.6] [background-image:linear-gradient(transparent_60%,rgb(167,243,208,0.5)_40%)] [-webkit-box-decoration-break:clone] [box-decoration-break:clone] px-1";
  
  return (
    <Component id={id} className={`${baseClasses} ${sizeClasses[size]} ${className}`}>
      <span className="relative">
        <span className={highlightClasses}>
          {children}
        </span>
      </span>
    </Component>
  );
};

export default HeadingHighlight; 